// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBsXkIy04tNgJuUE9fEyNTs6oqJ3zJHy6w",
    authDomain: "zbaide.firebaseapp.com",
    projectId: "zbaide",
    storageBucket: "zbaide.firebasestorage.app",
    messagingSenderId: "132932631100",
    appId: "1:132932631100:web:2ff7433d70ba947a4ce139"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db };
